<template>
  <div class="footer wrapper">
    <div class="BOLD">
      <a href="https://www.facebook.com/whitesidetimes" target="_blank">fb</a>
      <a href="https://www.instagram.com/whitesidetimes/" target="_blank">ins</a>
      <a href="https://vimeo.com/whiteside" target="_blank">vimeo</a>
    </div>
    <div class="BOLD">whitesidetimes.com © {{ years }} | <a href="https://github.com/zmts" target="_blank">DESIGNED BY ZMTS</a></div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    computed: {
      years () {
        return new Date().getFullYear() === 2018 ? 2018 : `2018 - ${new Date().getFullYear()}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .footer {
    display: flex;
    justify-content: space-between;
    font-family: $font-title;
    text-transform: uppercase;
    margin-top: auto;
    padding-top: 88px;
    padding-bottom: 88px;
    font-size: 25px;
    opacity: 0.2;
    a {
      color: $color-font-main;
      &:hover {
        color: $color-font-main;
        opacity: .5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue